<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Impuestos</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button type="button" @click="exportar" class="btn-success">
            <i class="fa fa-file-excel-o"></i>
            <span>Exportar</span>
          </button>
        </div>
      </div>
    </div>
    <k-table
      :filterStatus="filterStatus"
      @crear="crear"
      :createButton="createButton"
      :editButton="false"
      :deleteButton="false"
      ref="listaImpuestos"
      @seleccionar="seleccionar"
      :path="url + '/impuestos/search'"
      :columns="[
          {
            display : 'Código',
            value : 'id_tarifa'
          },
          {
            display : 'Descripción',
            value : 'descripcion'
          },
          {
            display : 'Porcentaje',
            value : 'porcentaje'
          },
          {
            display : 'T. específica',
            value : 'tarifa_especifica'
          },
          {
            display : 'Unidades',
            value : 'numero_unidades'
          },
          {
            display : 'T. Ed valorem',
            value : 'tarifa_ed_valorem'
          },
          {
            display : 'Retención',
            value : 'descripcion_aplica_retencion'
          },
          {
            display : 'Fecha Habilitación',
            value : 'fecha_habilitacion'
          }
        ]"
    ></k-table>
    <modal :width="'80%'" height="auto" :scrollable="true" name="impuesto">
      <item :searchButton="searchButton" @created="createdImpuesto"></item>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    createButton: {
      type: Boolean,
      required: false,
      default: true
    },
    filterStatus: {
      type: Boolean,
      required: false,
      default: true
    },
    searchButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function() {
    return {
      currentIndex: -1,
      url: url
    };
  },
  methods: {
    exportar: function() {
      let form = this.$refs.listaImpuestos.form;
      window.open(
        url +
          "/impuestos/search?status=" +
          form.status +
          "&search=" +
          form.search +
          "&exportar=S",
        "_blank"
      );
    },
    seleccionar: function(currentImpuesto) {
      this.$emit("selected", currentImpuesto);
    },
    crear: function() {
      this.$modal.show("impuesto");
    },
    createdImpuesto: function(impuesto) {
      this.$refs.listaImpuestos.actualizarLista(impuesto);
      this.$modal.hide("impuesto");
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/impuestos/ListaImpuestos.vue